<template>
  <div v-if="pagination" class="text-xs-center">
    <v-pagination
      v-model="pagination.page"
      :length="pagination.lastPage"
      :total-visible="7"
      circle
      v-on:input="$emit('change-page', pagination.page)"
      :disabled="disabled || pagination.lastPage === 1"
      prev-icon="fa-caret-left"
      next-icon="fa-caret-right"
    ></v-pagination>
  </div>
</template>

<script>
export default {
  name : 'app-pagination',
  props : ['pagination', 'disabled'],
  data () {
    return {
      
    };
  },
  created () { 
    
  },
  computed: {
    
  }
};
</script>
<style scoped lang="css">
>>>.v-pagination li:first-child .v-pagination__navigation .v-icon {
  margin-left: -5px;
}
>>>.v-pagination li:last-child .v-pagination__navigation .v-icon {
  margin-left: 5px;
}
</style>
